import { render } from "./OnlineAgentRegisterView.vue?vue&type=template&id=6491aa3e"
import script from "./OnlineAgentRegisterView.vue?vue&type=script&lang=js"
export * from "./OnlineAgentRegisterView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__